import { SystemStyleObject } from '@chakra-ui/react';
import { HamburgerStyleProps } from './styles';

export const getColorStyles = (props: HamburgerStyleProps): SystemStyleObject => ({
  color: props.color || 'black',
});
